import { render, staticRenderFns } from "./NavProjectMobile.vue?vue&type=template&id=2d427bda&"
import script from "./NavProjectMobile.vue?vue&type=script&lang=js&"
export * from "./NavProjectMobile.vue?vue&type=script&lang=js&"
import style0 from "./NavProjectMobile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* nuxt-component-imports */
installComponents(component, {NavItems: require('/lasso/components/NavItems.vue').default})


/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d427bda')) {
      api.createRecord('2d427bda', component.options)
    } else {
      api.reload('2d427bda', component.options)
    }
    module.hot.accept("./NavProjectMobile.vue?vue&type=template&id=2d427bda&", function () {
      api.rerender('2d427bda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/NavProjectMobile.vue"
export default component.exports